import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import PopupCloseButton from "@components/elements/PopupCloseButton";
import { activityPopState } from "@stores/popup";
import playSound from "@/sound";
import { useAtom, useAtomValue } from "jotai";
import ActivityType1 from "./ActivityType1";
import ActivityType2 from "./ActivityType2";
import ActivityType3 from "./ActivityType3";
import { randomRange } from "@stores/vars";
import { blockTouch, currentPageState } from "@stores/vars";
import useModal from "@hooks/useModal";

const Wrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #009cff;
  z-index: 105;
  animation: fullDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  .swiper {
    overflow: hidden;
    border-radius: 50px;
  }
`;

const NextButton = styled.button`
  position: absolute;
  width: 187px;
  height: 158px;
  top: 50%;
  right: -1px;
  transform: translateY(-50%);
  background: url(${require("@assets/img/activity_pop_next.png")}) no-repeat;
  &.disabled {
    pointer-events: none;
    opacity: 0.2;
  }
`;
const PrevButton = styled.button`
  position: absolute;
  width: 185px;
  height: 158px;
  top: 50%;
  left: -1px;
  transform: translateY(-50%);
  background: url(${require("@assets/img/activity_pop_prev.png")}) no-repeat;
  &.disabled {
    pointer-events: none;
    opacity: 0.2;
  }
`;

const IndicatorWrap = styled.div`
  position: absolute;
  right: 50px;
  top: 50px;
`;

const Indicator = styled.span`
  width: 47px;
  height: 33px;
  display: inline-block;
  border-radius: 20px;
  background-color: #000;
  opacity: 0.2;
  margin: 0 10px;
  &.on {
    opacity: 0.7;
  }
`;
const gameEndM = [
  require("@data/assets/_static/sounds/activity_end_m1.mp3"),
  require("@data/assets/_static/sounds/activity_end_m2.mp3"),
];
const gameEndW = [
  require("@data/assets/_static/sounds/activity_end_w1.mp3"),
  require("@data/assets/_static/sounds/activity_end_w2.mp3"),
];

const Activity = () => {
  const [curInfo, setInfo] = useAtom(activityPopState);
  const [possibleCount, setPossibleCount] = useState(0);
  const [count, setCount] = useState(0);
  const { showAlert } = useModal();
  const currentPage = useAtomValue(currentPageState);

  const onClose = () => {
    setInfo({
      open: false,
      questions: [],
    });
  };

  const onReset = () => {
    setCount(0);
    setPossibleCount(0);
  };

  const onNext = (e) => {
    blockTouch();
    const nextCount = Math.min(curInfo.questions.length - 1, count + 1);
    setCount(nextCount);
  };
  const onPrev = (e) => {
    blockTouch();
    const nextCount = Math.max(0, count - 1);
    setCount(nextCount);
  };

  const onSuccess = () => {
    if (count === curInfo.questions.length - 1) {
      playSound.effect(require("@assets/sounds/effects/activity_end.mp3"));

      if (window.__welcomeRandom[0]) {
        playSound.word(gameEndM[randomRange(0, 1)]);
      } else {
        playSound.word(gameEndW[randomRange(0, 1)]);
      }
      showAlert(
        "학습을 완료했습니다.<br/>이전페이지로 이동할까요?",
        "complete"
      ).then((value) => {
        if (value === false) {
          onReset();
        } else {
          onClose();
        }
      });
      blockTouch(false);
    } else {
      setPossibleCount(possibleCount + 1);
      setCount(count + 1);
    }
  };

  const renderActivity = useMemo(() => {
    //playSound.effect(swapSound);
    const currentType = curInfo.questions[count].type;
    blockTouch(false);
    if (currentType === "ty1") {
      return (
        <ActivityType1 data={curInfo.questions[count]} onSuccess={onSuccess} />
      );
    } else if (currentType === "ty2") {
      return (
        <ActivityType2 data={curInfo.questions[count]} onSuccess={onSuccess} />
      );
    } else if (currentType === "ty3") {
      return (
        <ActivityType3 data={curInfo.questions[count]} onSuccess={onSuccess} />
      );
    } else {
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  const isPossibleNext = () => {
    if (possibleCount === 0) return false;
    if (count === curInfo.questions.length - 1) return false;
    if (possibleCount > count) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    document.body.classList.add("has-popup");
    playSound.bgm(require("@assets/sounds/bgm/activity.mp3"));

    return () => {
      if (currentPage === "main") {
        playSound.bgm(require("@assets/sounds/bgm/main.mp3"));
      } else if (currentPage === "book") {
        playSound.bgm(require("@assets/sounds/bgm/book.mp3"));
      }
      document.body.classList.remove("has-popup");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrap className="pop-activity">
      <div>{renderActivity}</div>
      <NextButton
        type="button"
        onClick={onNext}
        className={isPossibleNext() === true ? "" : "disabled"}
      />
      <PrevButton
        type="button"
        onClick={onPrev}
        className={count === 0 && "disabled"}
      />
      <IndicatorWrap>
        {curInfo.questions.map((d, i) => {
          return <Indicator key={i} className={i === count ? "on" : ""} />;
        })}
      </IndicatorWrap>
      <PopupCloseButton onClick={onClose} />
    </Wrap>
  );
};

export default Activity;
